import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasContentAccess, paymentGraceEndsAt } from '../utils/contentAccess';

const formatDeadline = (ms) =>
  new Date(ms).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/London' });

/** Top-of-page "please update your card" bar for a failed-card account (parent and child views). */
export function PaymentFailedBanner() {
  const { user } = useAuth();
  if (user?.accessStatus !== 'payment_failed') return null;

  const inGrace = hasContentAccess(user);
  const endsAt = paymentGraceEndsAt(user);

  return (
    <div role="alert" className="bg-amber-50 border-b border-amber-300 text-amber-900">
      <div className="max-w-6xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-center">
        <span>
          {inGrace && endsAt !== null ? (
            <>
              Your last payment didn't go through. Please update your card by{' '}
              <strong>{formatDeadline(endsAt)}</strong> to keep lessons going.
            </>
          ) : (
            "Lessons are paused because your last payment didn't go through. Please update your card."
          )}
        </span>
        <Link
          to="/manage-subscription"
          className="shrink-0 rounded-md bg-amber-600 px-3 py-1 font-semibold text-white hover:bg-amber-700"
        >
          Update card
        </Link>
      </div>
    </div>
  );
}
